import { store } from "@/store";
import { OrganizationRest } from "@/services/rest/organization.rest";
import OrganizationInterface from "@/interfaces/Organization.interface";

export class OrganizationService{
    constructor(
        private _organizations = new OrganizationRest()
    ){}

    getOrganizations(params: any){
        return this._organizations.getOrganizations(params).then((response) => {
            store.dispatch('orgs/setOrganizations', response)
        });
    }

    getOrganizationById(id: any){
        return this._organizations.getOrganizationById(id).then((response) => {
            store.dispatch('orgs/setOrganization', response)
        });
    }

    addOrganization(data: OrganizationInterface): Promise<any>{
        return this._organizations.addOrganization(data)
    }

    updateOrganization(id: any, data: any){
        return this._organizations.updateOrganization(id, data)
    }

    deleteOrganization(id: string): Promise<any>{
        return this._organizations.deleteOrganization(id).catch((error) => {
            throw error.response.data
        })
    }

    updateStatus(id: string): Promise<any>{
        return this._organizations.updateOrganizationStatus(id)
    }

    getAdressData(cep: any): Promise<any>{
        return this._organizations.getAdressData(cep)
    }

    //Contact Organization Rest

    getContactOrganization(organizationId: any, params: any){
        return this._organizations.getContactOrganization(organizationId, params).then((response) => {
            return response;
        });
    }

    getContactOrganizationById(organizationId: any, id: any){
        return this._organizations.getContactOrganizationById(organizationId, id).then((response) => {
            return response;
        });
    }

    addContactOrganization(organizationId: any, data: any){
        return this._organizations.addContactOrganization(organizationId, data)
    }

    updateContactOrganization(organizationId: any, id: any, data: any){
        return this._organizations.updateContactOrganization(organizationId, id, data)
    }

    deleteContactOrganization(organizationId: any, id: any){
        return this._organizations.deleteContactOrganization(organizationId, id).catch((error) => {
            throw error.response.data
        })
    }

}